/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2CalendarNoShowIcon/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2CalendarNoShowIcon({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2CalendarNoShowIcon",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 10,
  height = 10,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#323F4B"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2CalendarNoShowIcon.Svg"
  data-view-path={viewPath}
 viewBox="0 0 10 10"
 style={{'--as-1-28h0PV': alignSelf,'--mt-2-28h0PV': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-28h0PV': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-28h0PV': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-28h0PV': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-28h0PV': opacity,'--w-10-28h0PV': typeof width === 'number' ? `${width}px` : width,'--h-11-28h0PV': typeof height === 'number' ? `${height}px` : height,'--f-12-28h0PV': fill,'--a-7-28h0PV': isAnimated ? animation : "none",'--sd-8-28h0PV': isAnimated ? strokeDashoffset : 0,'--sd-9-28h0PV': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2CalendarNoShowIcon.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M6.843 2.308a2.308 2.308 0 11-4.615 0 2.308 2.308 0 014.615 0zm.16 3.972v1.028c0 .292.082.565.223.798a1.724 1.724 0 00-.372 1.51h-5.78A.385.385 0 01.69 9.23a3.846 3.846 0 016.314-2.95zm1.539-1.857c.318 0 .577.258.577.577v2.308a.577.577 0 01-1.154 0V5c0-.319.258-.577.577-.577zm-.77 4.808a.77.77 0 111.539 0 .77.77 0 01-1.538 0z"
 style={{'--f-12-28h0PV': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}